require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./polychinelle-1-1-16-1.json") })
        }
      }, "path---polychinelle-1-1-16-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---polychinelle-1-1-16-1!./.cache/json/polychinelle-1-1-16-1.json
// module id = 526
// module chunks = 231608221292675